(() => {
  const PARAM = 'filter.p.m.custom.profesion';
  if (window.__utProfesionFilterInit) return;
  window.__utProfesionFilterInit = true;

  function getParam() {
    return new URL(location.href).searchParams.get(PARAM) || '';
  }

  function setParam(value) {
    const url = new URL(location.href);
    if (value) url.searchParams.set(PARAM, value);
    else url.searchParams.delete(PARAM);
    history.replaceState({}, '', url.toString());
  }

  function applyFilter(value) {
    const cards = document.querySelectorAll('product-card[data-product-id]');
    let visible = 0;
    cards.forEach((card) => {
      const raw = card.getAttribute('data-profesiones') || '';
      const decoded = raw
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
      const list = decoded.split('|').map((s) => s.trim()).filter(Boolean);
      const show = !value || list.includes(value);
      const li = card.closest('li') || card;
      li.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });
    document.querySelectorAll('[data-ut-profesion-status]').forEach((el) => {
      el.textContent = value || '';
      el.classList.toggle('facets__bubble', !!value);
    });
    document.querySelectorAll('[data-ut-profesion-value]').forEach((input) => {
      input.checked = !!value && input.getAttribute('data-ut-profesion-value') === value;
    });
    // Update catalog hint links
    document.querySelectorAll('[data-ut-profesion-filter]').forEach((panel) => {
      const checked = panel.querySelector('[data-ut-profesion-value]:checked');
      let hint = panel.querySelector('.ut-profesion-filter__hint');
      if (!checked) {
        if (hint) hint.remove();
        return;
      }
      const label = checked.getAttribute('data-ut-profesion-value');
      const handle = checked.getAttribute('data-ut-profesion-handle');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'ut-profesion-filter__hint';
        hint.style.cssText = 'margin:0.75rem 0 0;font-size:0.85em;opacity:0.85;';
        panel.querySelector('.facets__inputs-wrapper')?.appendChild(hint);
      }
      hint.innerHTML = `<a href="/collections/${handle}">Ver catálogo completo de ${label}</a>`;
    });
    const countEl = document.querySelector('[data-testid="products-count"], .products-count-wrapper');
    if (countEl && cards.length) {
      const n = visible;
      const label = n === 1 ? '1 artículo' : `${n} artículos`;
      // Prefer replacing just a number+word node if present
      const textNode = [...countEl.childNodes].find((n) => n.nodeType === 3 && /\d/.test(n.textContent||''));
      if (textNode) textNode.textContent = ` ${label} `;
      else {
        const span = countEl.querySelector('span, p') || countEl;
        if (/\d+\s*art/.test(span.textContent||'')) {
          span.textContent = (span.textContent||'').replace(/\d+\s*art[íi]culos?/i, label);
        }
      }
    }
    return visible;
  }

  function onChange(e) {
    const input = e.target.closest('[data-ut-profesion-value]');
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    const value = input.checked ? input.getAttribute('data-ut-profesion-value') : '';
    // exclusive single-select
    document.querySelectorAll('[data-ut-profesion-value]').forEach((el) => {
      if (el !== input) el.checked = false;
    });
    setParam(value);
    applyFilter(value);
  }

  document.addEventListener('change', onChange, true);
  document.addEventListener('DOMContentLoaded', () => applyFilter(getParam()));
  // Section rendering / facets may re-render
  document.addEventListener('shopify:section:load', () => applyFilter(getParam()));
  applyFilter(getParam());
})();
